import { render, staticRenderFns } from "./DownloadReportSection.vue?vue&type=template&id=2bad3842&scoped=true"
import script from "./DownloadReportSection.vue?vue&type=script&lang=js"
export * from "./DownloadReportSection.vue?vue&type=script&lang=js"
import style0 from "./DownloadReportSection.vue?vue&type=style&index=0&id=2bad3842&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bad3842",
  null
  
)

export default component.exports